(() => {
  'use strict';
  const controllers = new WeakMap();

  function initialize(root) {
    if (!root || controllers.has(root)) return;
    const rail = root.querySelector('.nh-arrival-products');
    const previous = root.querySelector('[data-noho-arrival-prev]');
    const next = root.querySelector('[data-noho-arrival-next]');
    if (!rail || !previous || !next) return;

    const controller = new AbortController();
    const options = { signal: controller.signal };
    function update() {
      previous.disabled = rail.scrollLeft < 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }
    function shift(direction) {
      const card = rail.querySelector('.nh-product');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(rail).gap) || 12;
      rail.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap) * 2,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    previous.addEventListener('click', () => shift(-1), options);
    next.addEventListener('click', () => shift(1), options);
    rail.addEventListener('scroll', update, { ...options, passive: true });
    window.addEventListener('resize', update, options);
    const observer = new ResizeObserver(update);
    observer.observe(rail);
    controllers.set(root, () => { controller.abort(); observer.disconnect(); });
    update();
  }

  initialize(document.getElementById('noho-homepage'));
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.querySelector('#noho-homepage'));
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('#noho-homepage');
    const destroy = root && controllers.get(root);
    if (destroy) { destroy(); controllers.delete(root); }
  });
})();
